<template>
  <b-form @submit.prevent="submitSearch" class="w-100">
        <div class="d-flex align-items-center">
          <div
              class="fake-search-input d-flex align-items-center"
              :class="{ 'cursor-pointer': hideSearch, 'no-caret': hideSearch, 'bg-light': disabledSubmit }"
              :style="containerStyle"
              @click="onFakeInputClick"
          >
            <div
              class="ml-2 mr-1 d-flex flex-shrink-0 align-items-center"
              :class="(isOpen && hideSearch) ? 'text-primary' : 'text-muted'"
            >
              <font-awesome-icon :icon="hideSearch ? 'sliders-h' : 'search'"/>
            </div>

            <b-form-input
              ref="searchInput"
              class="search-field px-2 border-0 shadow-none bg-transparent"
              :class="{ 'cursor-pointer': hideSearch }"
              size="sm"
              :value="query"
              :disabled="disabledSubmit"
              :placeholder="hideSearch ? 'Фильтры' : 'Поиск...'"
              :readonly="hideSearch"
              autocomplete="off"
              @input="onInput"
            />

            <div v-if="filterTags.length" class="badges-container d-flex flex-wrap align-items-center">
              <b-badge
                v-for="(tag, index) in filterTags"
                :key="index"
                variant="secondary"
                class="filter-badge mr-1 d-flex align-items-center"
              >
                <span class="text-truncate" style="max-width: 150px;">{{ tag.label }}</span>
                <font-awesome-icon
                  icon="times"
                  class="ml-1 cursor-pointer"
                  size="sm"
                  @click.stop="$emit('remove-tag', tag)"
                />
              </b-badge>
            </div>
          </div>

          <div v-if="$slots.default && !hideSearch" class="ml-1 d-flex align-items-center">
            <b-button
              size="sm"
              variant="link"
              class="py-0 px-2 text-dark"
              @click.stop="toggleOpen"
            >
              <font-awesome-icon icon="sliders-h" :class="{ 'text-primary': isOpen }"/>
            </b-button>
          </div>

          <b-button
            v-if="!hideSearchButton"
            size="sm"
            variant="primary"
            :disabled="isBusy || disabledSubmit"
            class="search-btn ml-1 px-3 d-flex align-items-center border-0"
            @click="submitSearch"
          >
            Найти
          </b-button>
        </div>
        <transition name="flyout">
          <div v-show="isOpen" class="filters-flyout">
            <b-card no-body bg-variant="light" class="shadow-lg h-100 d-flex flex-column overflow-hidden">
              <div class="px-3 py-2 border-bottom rounded-top d-flex justify-content-between align-items-center flex-shrink-0">
                <h5 class="mb-0">Фильтры</h5>
                <b-button size="sm" variant="link" class="text-dark p-0" @click="toggleOpen">
                  <font-awesome-icon icon="times"/>
                </b-button>
              </div>

              <div class="px-3 pb-2 pt-1 flyout-body bg-white overflow-auto flex-grow-1">
                <b-row>
                  <slot></slot>
                </b-row>
              </div>

              <div class="px-3 py-2 border-top rounded-bottom d-flex justify-content-between align-items-center flex-shrink-0">
                <b-button variant="link" class="text-danger p-0" size="sm" @click="onClear">
                  Очистить фильтры
                </b-button>
                <b-button variant="primary" size="sm" class="px-3" :disabled="disabledSubmit" @click="submitSearch">
                  Найти
                </b-button>
              </div>
            </b-card>
          </div>
        </transition>
      </b-form>
</template>
<script>
import {debounce} from "lodash";

export default {
  name: 'FiltersDrawer',
  props: {
    query: { type: String, default: '' },
    isBusy: { type: Boolean, default: false },
    filterTags: { type: Array, default: () => [] },
    hideSearch: { type: Boolean, default: false },
    hideSearchButton: { type: Boolean, default: false },
    disabledSubmit: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  created() {
    this.debouncedSearch = debounce(() => {
      this.$emit('submit');
    }, 300);
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  computed: {
    containerStyle() {
      let width = 'auto';

      const isInactive = this.filterTags.length === 0 && !this.query;

      if (isInactive) {
        width = '20%';
      }

      return {
        width: width,
        minWidth: '320px',
        maxWidth: '100%'
      };
    }
  },
  methods: {
    onFakeInputClick() {
      if (this.hideSearch) this.toggleOpen();
    },
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    onInput(value) {
      if (this.hideSearch) return;

      this.$emit('update:query', value);
      this.debouncedSearch();
    },
    submitSearch() {
      if (this.debouncedSearch) this.debouncedSearch.cancel();

      this.$emit('submit');
      this.isOpen = false;
    },
    onClear() {
      if (this.debouncedSearch) this.debouncedSearch.cancel();

      this.$emit('clear');
    },
    handleOutsideClick(e) {
      if (!this.isOpen) return;

      if (this.$el.contains(e.target)) return;

      if (e.target.closest('.modal, .popover, .tooltip, .dropdown-menu')) return;

      this.isOpen = false;
    }
  }
};
</script>

<style scoped>
.fake-search-input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  flex-wrap: wrap;
  overflow: visible;
  height: auto;
  min-height: 31px;
  transition: all 0.2s ease-in-out;
}

.fake-search-input:focus-within {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.search-field {
  flex: 1 1 150px;
  min-width: 150px;
  height: 26px;
}

.badges-container {
  flex: 1 1 auto;
  max-width: 100%;
  overflow: visible;
  justify-content: flex-end;
}

.filter-badge {
  height: 22px;
  margin-top: 2px;
  margin-bottom: 2px;
  font-weight: normal;
  font-size: 0.8rem;
  line-height: 2;
  background-color: #e9ecef;
  color: #495057;
}

.search-btn {
  height: 26px;
}

.cursor-pointer {
  cursor: pointer;
}

.filters-flyout {
  position: absolute;
  top: calc(100% + 10px);
  width: 450px;
  max-width: 90vw;
  max-height: 75vh;
  z-index: 10;
  transform-origin: top right;
  display: flex;
  flex-direction: column;
}

.filters-flyout .card {
  max-height: inherit;
}

.flyout-body {
  min-height: 0;
}

.flyout-enter-active,
.flyout-leave-active {
  transition: all 0.25s cubic-bezier(0.165, 0.85, 0.45, 1);
  opacity: 1;
  transform: scale(1) translateY(0);
}

.flyout-enter,
.flyout-leave-to {
  opacity: 0;
  transform: scale(0.95) translateY(-10px) translateX(10px);
}

.no-caret {
  caret-color: transparent;
  outline: none !important;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/FiltersDrawer.vue